﻿import { Component, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';


@Component({ templateUrl: 'empezar.component.html' })
export class EmpezarComponent implements OnInit {

    crearForm: FormGroup;
    loading = false;
    submitted = false;

    constructor(
        private formBuilder: FormBuilder,
        private router: Router
        ) {
    }

    ngOnInit() {
        this.crearForm = this.formBuilder.group({
            name: ['', Validators.required],
            codigo: ['', Validators.required]
        });
    }


    


    // convenience getter for easy access to form fields
    get f() { return this.crearForm.controls; }

    onSubmit() {
        this.submitted = true;

        if (this.crearForm.invalid) {
            return;
        }
        this.loading = true;
        this.router.navigate(['/elegir'], { queryParams: { nombre : this.f.name.value , codigo: this.f.codigo.value }});
    }


}
